import { useInView, useReducedMotion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

/**
 * 只在元素进入视口时推进的计时器，用于驱动模拟界面的"实时感"。
 *
 * 两个必要的约束：
 * 1. 不可见时停止。页面上有 5 个模拟界面，若全部常驻跑 interval，
 *    会持续占用主线程并拖累滚动流畅度。
 * 2. reduced-motion 时完全不启动，返回固定 tick，界面呈现静态快照。
 *
 * 返回的 ref 需挂在被观测的容器上。
 */
export function useVisibleTicker(intervalMs: number) {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { margin: '-5%' });
  const reduce = useReducedMotion();
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!inView || reduce) return;
    const id = window.setInterval(() => setTick((t) => t + 1), intervalMs);
    return () => window.clearInterval(id);
  }, [inView, reduce, intervalMs]);

  return { ref, tick, active: inView && !reduce };
}
